<template>
  <div class="page-wrapper">
    <div class="page-wrapper__top">
      <InitioHeader />
      <slot></slot>
    </div>
    <div class="page-wrapper__bottom">
      <footer class="page-footer">
        <div class="container">
          <div class="navbar-footer">
              <div class="navbar-footer__rows">
                <div class="navbar-start">
                  <a href="/terms-and-conditions/" target="_blank" class="navbar-item has-text-centered-mobile ">
                    Terms &amp; Conditions
                  </a>
                  <a href="/privacy-policy/" target="_blank" class="navbar-item has-text-centered-mobile ">
                    Privacy Policy
                  </a>
                  <a href="/disclosure-statement/" target="_blank" class="navbar-item has-text-centered-mobile ">
                    Disclosure Statement
                  </a>
                  <a href="/financial-strength/" target="_blank" class="navbar-item has-text-centered-mobile ">
                    Insurer Financial Strength Rating
                  </a>
                </div>
              </div>
          </div>
          <div class="page-footer__note">
            <div class="columns is-marginless">
              <div class="column has-text-centered-mobile">
                <p>Initio Insurance underwritten by IAG New Zealand Limited</p>
              </div>
              <div class="column ">
                <p class="has-text-right-tablet has-text-centered-mobile">Copyright &copy; Initio {{ currentYear }}</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>


import InitioHeader from './InitioHeader.vue'

export default {
  components: {
    InitioHeader
  },
  data() {
    return {}
  },
  computed: {
    currentYear: function(){
      return  new Date().getFullYear();
    }
  }
}
</script>

<style scoped lang="scss">

.page-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}

.page-wrapper__top {

}
.page-wrapper__bottom {

}

footer.page-footer {
  background: #f5f5f5;
  color: $grey-text;
  padding-top: 25px;
  padding-bottom: 30px;
}

footer.page-footer .navbar-footer {
  padding: 15px 0;
  border-bottom: 1px solid rgba(191, 188, 188, 0.19);
  margin-bottom: 20px;
  font-size: 14px;
  display: flex;
  align-items: stretch;
  @include mobile(){
    display: block;
  }
}

footer.page-footer .navbar-item {
  padding: 0;
  margin-right: 20px;
}

footer.page-footer a {
  color: #717f86;
  &:hover {
    color: $bright-blue;
    background: none;
  }
}

</style>
